import {getEvent} from '../../../selectors/event'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {FullLocation as FullLocationPresentation, FullLocationProps} from './full-location'

const mapRuntime = ({state}: DetailsPageAppProps): FullLocationProps => ({
  event: getEvent(state),
})

export const FullLocation = connect<{}, FullLocationProps>(mapRuntime)(FullLocationPresentation)
